<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'upload-report.title'">_Subir versión</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="'upload-report.description'">_Si has editado en local una versión del informe, puedes subir al listado el documento modificado. Se subirá como versión nueva.</p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-onefile
        [field]="uploadReport.fieldInfo"
        (itemSelected)="fileSelected($event)"
        [fileInfo]="uploadReport.fileInfo">
      </field-type-onefile>
      <field-type-text-simple
        [field]="uploadReport.nameInfo"
        [preSelectItem]="uploadReport.name"
        (itemSelected)="nameSelected($event)">
      </field-type-text-simple>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="validateFields()">
      <span class="common-button__text-title"
        [afTranslate]="'common.upload'">_Subir</span>
    </button>
  </div>
</div>
